import Isikukood from 'isikukood';

export function personId(value) {
  const instance = new Isikukood(value.toString());

  return instance.validate();
}

export function equalTo(value, anotherValue) {
  return value === anotherValue;
}

export function phone(value) {
  if (typeof value !== 'string' || value === '') {
    return true;
  }
  return value.replace(/ /g, '').search(/^(\+\d{3})?\d{6,}$/) !== -1;
}

export function email(value) {
  if (typeof value !== 'string' || value === '') {
    return true;
  }
  return value.search(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/) !== -1;
}
